import dayjs from "dayjs"


// console.log(dayjs(1752076800000).format('YYYY-MM-DD HH:mm:ss'))
// console.log(dayjs(1752737499308).format('YYYY-MM-DD HH:mm:ss'))
// console.log(dayjs("1752076800000", 'YYYY-MM-DD HH:mm:ss'))
// console.log(dayjs("1752737402553", 'YYYY-MM-DD HH:mm:ss'))


/**
 *
 * @param text 时间
 * @returns 'YYYY-MM-DD'格式的日期
 */
export const formatDate = (text, templateString = 'YYYY-MM-DD') => {
    if (!text) {
        return ''
    }
    return dayjs(text).format(templateString)
}

/**
 *
 * @param timestamp 时间戳
 * @returns 'YYYY-MM-DD'格式的日期
 */
export const formatTimestamp = (timestamp, templateString = 'YYYY-MM-DD') => {
    try {
        if (!timestamp) {
            return ''
        }

        if (Object.prototype.toString.call(timestamp) === '[object String]') {
            return dayjs(Number(timestamp)).format(templateString)
        }

        return dayjs(timestamp).format(templateString)
    } catch (error) {
        return ''
    }
}